import Tooltip from "../../../components/tooltip";
import Daily from "./Daily";
import Monthly from "./Monthly";

const OverviewDas = () => {
  return (
    <div className="tabContent">
      <div
        style={{ height: "calc(100vh - 90px)" }}
        className="grid grid-cols-12 gap-4 w-full px-4  p-4 md:overflow-hidden"
      >
        <Monthly />
        <Daily />
      </div>
      <div className="gna-footer-container">
        <div className="grid grid-cols-3 justify-between gap-5 ">
          <Tooltip
            note={<p>HPPC, Eltrix, WBES</p>}
            text=" Short Term Procurement % = (Collective + TGNA)/Total Discom Load   (2).
            Intrastate Generation = Eltrix schedule + NREB Grid Curves   (3).
            Interstate Generation = ISGS WBES   (4). MW = Represents the average
            (MW) when the selected time interval is Date or Month."
          >
            <p className="gna-footer-text">Source</p>
          </Tooltip>
          <p className="gna-footer-text col-span-1 text-center">
            Powered by <strong>GNA Energy</strong>
          </p>
          <strong className="gna-footer-text col-span-1 text-end">
            Beta Version
          </strong>
        </div>
      </div>
    </div>
  );
};

export default OverviewDas;
